import {isEmpty, isValidNumber} from '../../common/utils/ValidationUtils';
import {COUNTRIES} from './AppConstants';

export const ERROR_EMAIL_FORMAT = 'email incorrecto';
export const ERROR_NUMBER_FORMAT = 'solo números';
export const ERROR_DECIMAL_NUMBER_FORMAT = 'número incorrecto';
export const ERROR_PHONE = 'Debe ingresar un teléfono válido';
export const ERROR_ID_FORMAT = 'Debe ingresar un número de identificación válido';
export const ERROR_PARTNER_AND_CLIENT_ID_EQUALS = 'Cédula igual al solicitante';
export const ERROR_REQUIRED = 'campo requerido';
export const YEAR_OUT_OF_RANGE = 'Año fuera de rango';
export const YEAR_INVALID = 'Año inválido';
export const FIELD_UPLOAD_REQUIRED = 'Sube el archivo';
export const ERROR_MIN_LENGTH = getMinLengthErrorMessage;
export const ERROR_MIN_AGE = getMinYearAllowedErrorMessage;
export const ERROR_LESS_THAN_CURRENT = 'Debe ser mayor a la fecha actual';
export const ERROR_MAX_DATE = 'Fecha máxima: ';
export const ERROR_POSTAL_CODE_REQUIRED = 'Código postal requerido';
export const ERROR_TIME_REQUIRED = 'Hora o Minutos requeridos';
export const ERROR_POSTAL_CODE = 'Código postal inválido';
export const ERROR_EQUIFAX_REQUIRED = 'Debe aceptar los términos y condiciones';
export const ERROR_TERMS_MX_REQUIRED = 'Debe aceptar los términos de privacidad';
export const ERROR_REGISTER_TERMS_REQUIRED = 'Debes aceptar los términos y condiciones';
export const SUCCESS_MESSAGE_FORGET_PASSWORD = 'Enviamos las instrucciones para restablecer tu contraseña a ';
export const ERROR_MUST_CHOOSE_INSURANCE = 'Debes seleccionar una aseguradora';
export const ERROR_REPEATED_REFERENCE = 'Existen referencias duplicadas';
export const ERROR_SELECT_AN_ANSWER = 'Selecciona una respuesta';
export const ERROR_VALUE_GT_ZERO = 'Debe ingresar valor mayor a 0';
export const ERROR_REQUIRED_NIP = 'Ingresa el código de validación';
export const NIP_CHARACTERS = 6;
export const ERROR_PRICE = getPriceErrorMessage;
export const ERROR_DOWN_PAYMENT = getDownPaymentErrorMessage;

export function getMinLengthErrorMessage(length) {
    return `mínimo ${length} caracteres`;
}

export function getMinYearAllowedErrorMessage(age) {
    return `Debe tener mas de ${age} años`;
}

export function getMinValueAllowedErrorMessage(value) {
    return `Debe ingresar un valor mayor que ${value}`;
}

export function getMaxValueAllowedErrorMessage(value) {
    return `Debe ingresar un valor menor que ${value}`;
}

export function getPriceErrorMessage(price, minPrice, country = 'EC', currencySymbol = '$') {
    if (isEmpty(price)) {
        return ERROR_REQUIRED;
    }
    if (isValidNumber(price)) {
        return ERROR_NUMBER_FORMAT;
    }
    if (price < minPrice) {
        return `mínimo ${currencySymbol}${new Intl.NumberFormat(COUNTRIES[country].locale, {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(minPrice)}`;
    }
    return null;
}

export function getDownPaymentErrorMessage(price, entry, minDownPayment, maxDownPayment, country = 'EC',
                                           currencySymbol = '$') {
    if (isEmpty(entry)) {
        return ERROR_REQUIRED;
    }
    if (isValidNumber(entry)) {
        return ERROR_NUMBER_FORMAT;
    }
    if (isEmpty(price)) {
        return null;
    }
    if (entry < Math.ceil(price * minDownPayment)) {
        return `mínimo ${currencySymbol}${new Intl.NumberFormat(COUNTRIES[country].locale, {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(Math.ceil(price * minDownPayment))}`;
    }
    if (entry > Math.trunc(price * maxDownPayment)) {
        return `máximo ${currencySymbol}${new Intl.NumberFormat(COUNTRIES[country].locale, {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(Math.trunc(price * maxDownPayment))}`;
    }
    return null;
}

export const maxDownPaymentCalculate = (price, globalValidations) => {
    const maxValueByMaxDownPayment = price * globalValidations.maxDownPayment;
    const minValueByAmountFinancing = price - globalValidations.minAmountFinancing;
    return maxValueByMaxDownPayment > minValueByAmountFinancing ?
        minValueByAmountFinancing : maxValueByMaxDownPayment;
};

export const minDownPaymentCalculate = (price, globalValidations) => {
    const minValueByMaxDownPayment = price * globalValidations.minDownPayment;
    const maxValueByAmountFinancing = price - globalValidations.maxAmountFinancing;
    return minValueByMaxDownPayment < maxValueByAmountFinancing ?
        maxValueByAmountFinancing : minValueByMaxDownPayment;
};

export const currencyFormatter = (country = 'MX') => new Intl.NumberFormat(COUNTRIES[country].locale, {
    style: 'currency',
    currency: COUNTRIES[country].currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
